module.exports = __webpack_public_path__ + "static/media/tank.1245abc3.png";